// extracted by mini-css-extract-plugin
module.exports = {"toggleControl":"toggle-module--toggleControl--1RMqX","dmcheck":"toggle-module--dmcheck--1Iu6H"};